import Heading from '@/common/shared/heading'
import { Separator } from '@/common/ui/separator'
import GeneralSettingBox from '../GeneralSettingBox'
import { GetGeneralSettingResponse } from '@/modules/client-setting/type'
import NotificationSoundSetting from '@/modules/client-setting/components/NotificationSoundSetting'

interface GeneralSettingListingProps {
	data: GetGeneralSettingResponse
}

export default function GeneralSettingListing({
	data,
}: GeneralSettingListingProps) {
	return (
		<div className="space-y-4">
			<div className="flex items-start justify-between">
				<Heading title="ตั้งค่าทั่วไป" description="จัดการการตั้งค่าทั่วไป" />
			</div>
			<Separator />
			<GeneralSettingBox data={data} />
			<NotificationSoundSetting />
		</div>
	)
}
